import { Trident } from "./Logo";

const ITEMS = [
  "Custos × Margem × Faturamento",
  "Gestão por lotes",
  "Projetado × Realizado × Potencial",
  "Ponto de equilíbrio",
  "Margem de contribuição",
  "Resultado operacional",
  "Decisão baseada em indicadores",
];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="relative border-y border-white/[0.06] bg-tria-navy/60 py-6">
    <div className="mask-fade-x overflow-hidden">
      <div className="flex w-max animate-marquee items-center gap-10 pr-10">
        {[...ITEMS, ...ITEMS].map((item, i) => (
          <div key={i} className="flex items-center gap-10">
            <span className="whitespace-nowrap font-display text-lg font-medium tracking-wide text-white/70 sm:text-xl">
              {item}
            </span>
            <Trident id={`mq-${i}`} className="h-5 w-5 opacity-50" />
          </div>
        ))}
      </div>
    </div>
  </div>
);
